import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";
import { Quote } from "lucide-react";

const About = () => {
  const { t } = useLanguage();
  const r = useReveal();

  return (
    <section id="about" className="py-16 sm:py-24 md:py-32 bg-gradient-to-b from-brand-sand to-brand-cream">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 sm:gap-16 items-center">
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden shadow-[0_30px_70px_rgba(76,62,99,0.15)]">
            <img
              src={IMAGES.spiritual}
              alt="Francesca De Salvia"
              className="w-full h-[400px] sm:h-[500px] lg:h-[560px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 right-4 sm:right-6 bg-brand-plum text-brand-cream rounded-2xl px-6 py-4 shadow-xl">
            <p className="font-serif text-2xl leading-none">Tenerife</p>
            <p className="text-xs tracking-widest uppercase opacity-80 mt-1">España</p>
          </div>
        </div>

        <div ref={r.ref} className={r.className}>
          <p className="text-xs tracking-[0.4em] uppercase text-brand-gold mb-5">
            {t.about.kicker}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-brand-plumDark mb-3">
            {t.about.title}
          </h2>
          <p className="text-brand-sage font-medium mb-7">{t.about.role}</p>
          <p className="text-brand-ink/75 leading-relaxed mb-5">{t.about.p1}</p>
          <p className="text-brand-ink/75 leading-relaxed mb-8">{t.about.p2}</p>

          <blockquote className="relative bg-white/60 border-l-4 border-brand-gold rounded-r-2xl px-6 py-5">
            <Quote size={22} className="text-brand-gold/50 mb-2" />
            <p className="font-serif text-lg sm:text-xl md:text-2xl text-brand-plumDark italic leading-snug">
              {t.about.quote}
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default About;
